import { AxiosResponse } from "axios";
import { Dominios } from "../utils/enums";
import axiosInstance from "../interceptors/axiosInstance";
import { ListResponseDto } from "../dtos/ListResponseDto";
import { Emisor } from "../features/reportes/generarProcesosMasivos/models/generarArchivoProcesosMasivos";
import { selectorTransversal } from "../dtos/selector";

const getEmisores = async () => {
    const axiosResponse: Promise<AxiosResponse<ListResponseDto<Emisor>>> = axiosInstance.get(`siscred-api-transversal/v1/instituciones/obtener-datos-emisor`);
    return axiosResponse;
}

const getValoresDominio = async (codigoDominio: Dominios) => {

    const axiosResponse: Promise<AxiosResponse<ListResponseDto<selectorTransversal>>> = axiosInstance.get(`siscred-api-transversal/v1/dominio/obtener-datos-dominio`, {
        params: {
            codigoDominio: codigoDominio
        }
    });
    return axiosResponse;
}

const getEmisoresTablaDividendo = async () => {
    const axiosResponse: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-mutuo/v1/tablas-desarrollo/obtener-emisor`);
    return axiosResponse;
}


export {
    getEmisores,
    getValoresDominio,
    getEmisoresTablaDividendo
}